/*
 * @Author: dingzesheng
 * @Date: 2024-5-15 09:07:15
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-12-18 13:21:09
 * @FilePath: \projectManagementFrontd:\project\app\PosWholesaleClothing-Front\src\common\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export var padauthList = [
    {
        name: '主页数据',
        children: [
            {
                name: '查看',
                value: '001',
            },
            {
                name: '实销总额',
                value: '002',
            },
            {
                name: '销售订单',
                value: '003',
            },
            {
                name: '销售商品',
                value: '004',
            },
            {
                name: '新增会员',
                value: '005',
            },
            {
                name: '月度实销趋势',
                value: '006',
            },
            {
                name: '月度商品热销',
                value: '007',
            },
            {
                name: '退货订单',
                value: '008',
            },
            {
                name: '退回商品',
                value: '009',
            },
        ]
    },
    {
        name: '商品信息',
        children: [
            {
                name: '查看',
                value: '101',
            },
            {
                name: '新增商品',
                value: '102',
            },
            {
                name: '编辑商品',
                value: '103',
            },
            {
                name: '删除商品',
                value: '104',
            },
            {
                name: '上架商品',
                value: '105',
            },
            {
                name: '下架商品',
                value: '106',
            },
            {
                name: '分类编辑',
                value: '107',
            },
            {
                name: '字段-进货价',
                value: '108',
            },
            {
                name: '字段-供应商',
                value: '109',
            },
        ]
    },
    {
        name: '商品规格',
        children: [
            {
                name: '查看',
                value: '201',
            },
            {
                name: '编辑规格',
                value: '202',
            },
        ]
    },
    {
        name: '会员信息',
        children: [
            {
                name: '查看',
                value: '301',
            },
            {
                name: '编辑',
                value: '302',
            },
        ]
    },
    {
        name: '积分设置',
        children: [
            {
                name: '查看',
                value: '401',
            },
            {
                name: '编辑',
                value: '402',
            },
        ]
    },
    {
        name: '等级设置',
        children: [
            {
                name: '查看',
                value: '501',
            },
            {
                name: '编辑',
                value: '502',
            },
        ]
    },
    {
        name: '收银',
        children: [
            {
                name: '查看',
                value: '601',
            },
            {
                name: '改价',
                value: '602',
            },
            {
                name: '批量改价',
                value: '603',
            },
        ]
    },
    {
        name: '换货',
        children: [
            {
                name: '查看',
                value: '2501',
            },
        ]
    },
    {
        name: '退货',
        children: [
            {
                name: '查看',
                value: '701',
            },
        ]
    },
    {
        name: '员工信息',
        children: [
            {
                name: '查看',
                value: '801',
            },
            {
                name: '新增',
                value: '802',
            },
            {
                name: '编辑',
                value: '803',
            },
            {
                name: '删除',
                value: '804',
            },
        ]
    },
    {
        name: '提成设置',
        children: [
            {
                name: '查看',
                value: '901',
            },
            {
                name: '新增',
                value: '902',
            },
            {
                name: '编辑',
                value: '903',
            },
            {
                name: '删除',
                value: '904',
            },
        ]
    },
    {
        name: '角色与权限',
        children: [
            {
                name: '查看',
                value: '1001',
            },
            {
                name: '编辑权限',
                value: '1002',
            },
            {
                name: '删除角色',
                value: '1003',
            },
        ]
    },
    {
        name: '店铺信息',
        children: [
            {
                name: '查看',
                value: '1101',
            },
            {
                name: '编辑',
                value: '1102',
            },
        ]
    },
    {
        name: '支付设置',
        children: [
            {
                name: '查看',
                value: '1201',
            },
        ]
    },
    {
        name: '配件信息',
        children: [
            {
                name: '查看',
                value: '1301',
            },
            {
                name: '编辑',
                value: '1302',
            },
        ]
    },
    {
        name: '收银设置',
        children: [
            {
                name: '查看',
                value: '1401',
            },
            {
                name: '编辑',
                value: '1402',
            },
        ]
    },
    {
        name: '云同步设置',
        children: [
            {
                name: '查看',
                value: '1501',
            },
            {
                name: '编辑',
                value: '1502',
            },
        ]
    },
    {
        name: '销售总览报表',
        children: [
            {
                name: '查看',
                value: '2601',
            },
        ]
    },
    {
        name: '销售报表',
        children: [
            {
                name: '查看',
                value: '1601',
            },
        ]
    },
    {
        name: '商品报表',
        children: [
            {
                name: '查看',
                value: '1701',
            },
        ]
    },
    {
        name: '会员报表',
        children: [
            {
                name: '查看',
                value: '1801',
            },
        ]
    },
    {
        name: '员工报表',
        children: [
            {
                name: '查看',
                value: '1901',
            },
        ]
    },
    {
        name: '库存查询',
        children: [
            {
                name: '查看',
                value: '2001',
            },
        ]
    },
    {
        name: '库存盘点',
        children: [
            {
                name: '查看',
                value: '2101',
            },
        ]
    },
    {
        name: '供应商',
        children: [
            {
                name: '查看',
                value: '2201',
            },
            {
                name: '新增',
                value: '2202',
            },
            {
                name: '编辑',
                value: '2203',
            },
        ]
    },
    {
        name: '调拨',
        children: [
            {
                name: '查看',
                value: '2401',
            },
            {
                name: '调拨出库-查看',
                value: '2402',
            },
            {
                name: '调拨出库-新增',
                value: '2403',
            },
            {
                name: '调拨入库-查看',
                value: '2404',
            },
            {
                name: '调拨入库-接收',
                value: '2405',
            },
        ]
    },
    {
        name: '利润率',
        children: [
            {
                name: '查看',
                value: '2701',
            },
        ]
    },
    {
        name: '收银员',
        children: [
            {
                name: '查看',
                value: '2801',
            },
            {
                name: '新增',
                value: '2802',
            },
            {
                name: '编辑',
                value: '2803',
            },
            {
                name: '修改',
                value: '2804',
            },
        ]
    },
    {
        name: '会员调整',
        children: [
            {
                name: '余额调整',
                value: '2901',
            },
            {
                name: '积分调整',
                value: '2902',
            },
        ]
    },
]


// WEBPACK FOOTER //
// ./src/common/authpad.js